/**
 * @file config.js
 * @description Configuración global de la aplicación
 * @module config/config
 * 
 * CAMBIOS OPTIMIZACIÓN v3.0:
 * - Intervalo de polling aumentado de 5s a 30s
 * - Reducción de ~95% en queries a base de datos
 * - Polling inteligente que se pausa cuando la pestaña está inactiva
 */

// URL base de la API
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://host4.mine.nu'; // 'http://192.168.0.187:8000'; //

/**
 * POLLING_INTERVAL - Intervalo de actualización automática
 * 
 * OPTIMIZADO: 30 segundos (antes: 5 segundos)
 * 
 * IMPACTO EN QUERIES DE BASE DE DATOS:
 * - 5s  interval: 720 queries/hora por usuario
 * - 30s interval: 120 queries/hora por usuario
 * 
 * Con 5 usuarios concurrentes:
 * - Antes: 3,600 queries/hora (LÍMITE DE MYSQL)
 * - Ahora: 600 queries/hora (83% de reducción)
 * 
 * Con el sistema de estado global:
 * - Antes: 3,600+ queries/hora (múltiples hooks)
 * - Ahora: 120 queries/hora (una sola fuente de datos)
 * - Reducción: 97%
 */
export const POLLING_INTERVAL = 30000; // 30 segundos

/**
 * CACHE_TTL - Tiempo de vida del caché
 */
export const CACHE_TTL = 25000; // 25 segundos (ligeramente menor que el polling)

/**
 * REQUEST_TIMEOUT - Timeout para peticiones HTTP
 */
export const REQUEST_TIMEOUT = 20000; // 20 segundos

/**
 * MAX_RETRIES - Número máximo de reintentos para peticiones fallidas
 */
export const MAX_RETRIES = 3;

/**
 * DEBOUNCE_DELAY - Delay para debouncing de búsquedas
 */
export const DEBOUNCE_DELAY = 300; // 300ms

/**
 * FEATURES FLAGS - Habilitar/deshabilitar características
 */
export const FEATURES = {
  // Polling inteligente que se pausa cuando la pestaña está inactiva
  SMART_POLLING: true,

  // Sistema de estado global (siempre habilitado en v3.0)
  GLOBAL_STATE: true,

  // Logs de debugging en desarrollo
  DEBUG_LOGS: process.env.NODE_ENV === 'development',

  // Estadísticas de performance
  PERFORMANCE_STATS: process.env.NODE_ENV === 'development'
};

/**
 * PERFORMANCE - Configuración de optimizaciones
 */
export const PERFORMANCE = {
  // Tamaño máximo del caché de procesamiento
  MAX_CACHE_SIZE: 10,

  // Tamaño máximo del caché de filtros
  MAX_FILTER_CACHE_SIZE: 20,

  // Duración del caché de procesamiento (ms)
  PROCESSING_CACHE_TTL: 5000,

  // Duración del caché de filtros de vehículos (ms)
  FILTER_CACHE_TTL: 30000
};

/**
 * UI - Configuración de interfaz
 */
export const UI = {
  // Duración de transiciones (ms)
  SIDEBAR_TRANSITION_MS: 350,

  // Delay para animaciones
  ANIMATION_DELAY: 300,

  // Número de items por página en tablas
  ITEMS_PER_PAGE: 50
};

/**
 * ESTATUS - Definición de estatus de vehículos
 */
export const ESTATUS = {
  INVENTARIO:               1,
  NO_MAYOREADO:             2,
  EN_TRANSITO:              3,
  TRASPASO_SIN_RECIBIR:     5,
  FACTURADO_NO_ENTREGADO:   6,
  ENTREGADO_STANDBY:        7,
};

/**
 * MARCAS - Marcas disponibles
 */
export const MARCAS = ['FORD', 'LINCOLN', 'MAZDA', 'GWM'];

export default {
  API_BASE_URL,
  POLLING_INTERVAL,
  CACHE_TTL,
  REQUEST_TIMEOUT,
  MAX_RETRIES,
  DEBOUNCE_DELAY,
  FEATURES,
  PERFORMANCE,
  UI,
  ESTATUS,
  MARCAS
};